import React from 'react';

import {
  selectDiffMode,
  selectIsComplexOutcomeIslandOpen,
  selectMergedOutcomeActions,
  selectOutcomeActions,
} from 'flow/store/redux/selectors';

import { useAppSelector } from '~/store/reduxHooks';

import SimpleOutcomeIsland from './SimpleOutcomeIsland';
import ComplexOutcomeIsland from './ComplexOutcomeIsland';
import { sortOutcomeActionsByPrecedenceIndex } from './helpers';


export default function OutcomeIsland() {
  const outcomeActions = useAppSelector(selectOutcomeActions);
  const mergedOutcomeActions = useAppSelector(selectMergedOutcomeActions);
  const isInDiffMode = useAppSelector(selectDiffMode);
  const isComplexIslandOpen = useAppSelector(selectIsComplexOutcomeIslandOpen);

  const Island = isComplexIslandOpen ? ComplexOutcomeIsland : SimpleOutcomeIsland;

  const islandOutcomeActions = isInDiffMode ? mergedOutcomeActions : outcomeActions;

  const sortedOutcomeActions = React.useMemo(
    () => sortOutcomeActionsByPrecedenceIndex([...islandOutcomeActions]), [islandOutcomeActions],
  );

  return (
    <Island data-pendo-anchor="evaluation-explainability-outcome-island" outcomeActions={sortedOutcomeActions} />
  );
}
